import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_ARENA } from '@/modules/arena/router';
import { arenaService } from '@/services/arena';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { reactive } from 'vue';

export function useArenaTicketAdd() {
    const router = useAppRouter();

    const model = reactive({
        type: null,
        name: ''
    });

    const validations = {
        type: { required },
        name: { required }
    };

    const v$ = useVuelidate(validations, model);

    const create = useCrudActions().excuteAndNotify({
        validator: v$,
        request: () => arenaService.ticket.update(model.type, model.name),
        onSuccess: () => router.push({ name: ROUTE_NAME_ARENA.TICKET.INDEX })
    });

    return { model, v$, create };
}
